module.exports = __webpack_public_path__ + "img/Oman.689f5a6c.svg";